export const loadTheme = (clientTitle) => {
    // Remove existing theme if present
    // Create new link tag
    const link = document.createElement("link");
    link.id = "tenant-theme";
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = `/css/${clientTitle}/theme.css?v=${new Date().getTime()}`;

    document.head.appendChild(link);
};
